<form (ngSubmit)="onSubmit()" #textJustificationForm="ngForm" ngForm="textJustificationForm">
  <div class="form-group">
    <div class="d-flex">
      <textarea class="form-control-lg" rows="5" cols="150" ngModel name="justification" #justification="ngModel"></textarea>
    </div>
    <div class="justify-content-left">
      <button [ngClass]="textJustificationForm.valid? 'btn-new-ui':'btn-new-ui-disabled'"
              type="submit"
              [disabled]="!textJustificationForm.valid">
        Submit
      </button>
    </div>
  </div>
</form>
